<script lang="ts">
    import { Route, Link, Router } from 'yrv'
    import SystemLog from './system-log.svelte'
    import Examples from '../../_common/z/_examples.svelte'
</script>

<div>
    <Router>
        <Route path="/log">
            <SystemLog></SystemLog>
        </Route>
        <Route path="/ex">
            <Examples></Examples>
        </Route>
    </Router>
</div>
